export const GLOBAL = {
    'ENV': 'global/ENVIRONMENT'
}

export default {}



// WEBPACK FOOTER //
// ./src/store/mutation-type.js